import Vue from 'vue'
import './assets/style.css'
import App from './App.vue'
import store from './store/store';
import VueCarousel from 'vue-carousel';
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import lazyload from './resources/js/directives/lazyload'
import { formatMoney } from './resources/js/helpers/money'

Vue.component('VueSlider', VueSlider)
Vue.config.productionTip = false
Vue.filter('money', formatMoney)
Vue.use(VueCarousel);

Vue.directive('lazy', lazyload);

Vue.directive('focus', {
  inserted: function (el) {
    el.focus();
  }
});

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
